/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const APPLICATION_CONFIRMATION = {
  DEFAULT_HEADER: 'Thank you for applying to this study!',
  DEFAULT_BODY: ["<p>You've successfully applied to the project and a researcher has been notified.</p>",
                 "<p>If you are selected as a participant, you'll receive an email with next steps.</p>"].join(''),
  PAGE_NAME: 'ApplicationConfirmation',
}
